<template>
  <div class="nx-list-action-preview">
    <v-list-tile v-if="list" @click.capture.stop="preview">
      <v-list-tile-action>
        <v-icon color="primary">preview</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        {{ $t('message.metadata.preview') }}
      </v-list-tile-content>
    </v-list-tile>
    <v-tooltip v-else top>
      <template #activator="{on}">
        <v-btn v-on="on" @click.capture.stop="preview" class="ma-0" icon flat>
          <v-icon color="primary" class="theme--light">preview</v-icon>
        </v-btn>
      </template>
      <strong v-html="$t('message.metadata.preview')"></strong>
    </v-tooltip>
    <v-dialog :value="showPreview"
              @input="close"
              scrollable
              lazy
              :fullscreen="fullscreen"
              max-width="800px">
      <v-toolbar v-if="fullscreen" dark color="nx-primary--darken-2" fixed>
        <v-btn icon dark @click.native="close">
          <v-icon color="accent">close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t('message.metadata.preview') }}</v-toolbar-title>
      </v-toolbar>
      <v-card class="nx-list-action-preview-card">
        <v-card-text class="card-content" :class="{ fullscreen }" ref="scrollable">
          <nx-entity-preview :id="id" :type="type"></nx-entity-preview>
        </v-card-text>
        <v-card-actions class="card-actions" v-if="!fullscreen">
          <v-layout row justify-end>
            <v-btn flat color="secondary" v-text="$t('message.common.close')" @click="close"></v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import NxEntityPreview from '@/modules/entity/preview/EntityPreview';

export default {
  name: 'nx-list-action-preview',
  components: { NxEntityPreview },
  props: {
    id: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    list: {
      type: Boolean,
    },
  },
  data() {
    return {
      showPreview: false,
    };
  },
  computed: {
    fullscreen() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    async preview() {
      this.showPreview = true;
      this.$nextTick(() => {
        this.$refs.scrollable.scrollTop = 0;
      });
    },
    close() {
      this.showPreview = false;
    },
  },
};
</script>

<style lang="stylus">
.nx-list-action-preview-card {
  .card-content {
    margin: 0;
    padding: 0;
    &.fullscreen {
      padding-top: 56px;
    }
  }

  .card-actions {
    border-top: 2px solid #e9e9f2;
  }
}
</style>
